import { useEffect, useRef, useState } from 'react'
import Images from '../../Images'
import './MarginDecoration.css'

function MarginDecoration () {
  const [pageHeight, setPageHeight] = useState<number>(
    document.body.scrollHeight
  )

  const resizeObserverRef = useRef<ResizeObserver | null>(null)

  useEffect(() => {
    const observeBodyScrollHeight = () => {
      setPageHeight(document.body.scrollHeight)
    }

    resizeObserverRef.current = new ResizeObserver(observeBodyScrollHeight)
    resizeObserverRef.current.observe(document.body)

    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect()
      }
    }
  }, [])

  return (
    <div className="margin-wrapper">
      <img
        className="r-3"
        style={{ top: 0.1 * pageHeight }}
        src={Images.GlobuleAB}
      />
      <img
        className="l-4"
        style={{ top: 0.13 * pageHeight }}
        src={Images.GlobuleA}
      />
      <img
        className="l1"
        style={{ top: 0.15 * pageHeight }}
        src={Images.GlobuleNeutre}
      />
      <img
        className="r1"
        style={{ top: 0.2 * pageHeight }}
        src={Images.GlobuleB}
      />
      <img
        className="r3"
        style={{ top: 0.35 * pageHeight }}
        src={Images.GlobuleA}
      />
      <img
        className="l2"
        style={{ top: 0.4 * pageHeight }}
        src={Images.GlobuleA}
      />
      <img
        className="r0"
        style={{ top: 0.45 * pageHeight }}
        src={Images.GlobuleAB}
      />
      <img
        className="l3"
        style={{ top: 0.55 * pageHeight }}
        src={Images.GlobuleB}
      />
      <img
        className="l1"
        style={{ top: 0.65 * pageHeight }}
        src={Images.GlobuleNeutre}
      />
    </div>
  )
}

export default MarginDecoration
